import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useEffect, useState, useRef } from 'react';
import { LangTranslate } from "../../types/types";
import { useLazyGetTranslationQuery, useSaveTranslationMutation } from "../../services/api/admin"
import TablePopup from '../modals/table-popup/tablePopup';
import TranslationPopup from '../modals/translationPopup/translationPopup';
import { useDispatch, useSelector } from 'react-redux';
import { setListTranslate } from '../../services/slices/admin.slice'
import cloneDeep from 'lodash/cloneDeep';
import { createUpdateTranslationsRequest, UpdateTranslationsRequest } from '../../services/types/translate.types'
import Loader from '../loader/loader';
import GeneralSuccessPopup from '../modals/generalSuccessPopup/generalSuccessPopup'
import GeneralErrorPopup from '../modals/errorPopup/errorPopup';
import Modal from '../modals/modal/Modal';
import { adminListSelector } from '../../services/selectors/admin.selectors'
import { result } from 'lodash';

interface Props {
  translationKey: string;
  text: string;
  onClose: () => void;
}

const AdminTextEditor: React.FC<Props> = ({ translationKey, text, onClose }) => {
  const [getTranslation] = useLazyGetTranslationQuery();
  const [saveTranslation] = useSaveTranslationMutation();
  const [success, setSuccess] = useState(false);
  const [textChange, setTextChange] = useState("");
  const [data, setData] = useState<LangTranslate[] | null>(null);
  const [translationsListFiltered, setTranslationsListFiltered] = useState<LangTranslate[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showTranslationPopup, setShowTranslationPopup] = useState(true);
  const [showTablePopup, setShowTablePopup] = useState(false);
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);
  const LangTranslateArr = useSelector(adminListSelector);
const [isAdmin,setIsAdmin]=useState("false")
  useEffect(()=>{
    if( sessionStorage.getItem("isAdmin")=="true"){      
      setIsAdmin("true")
    }

  })

  useEffect(() => {
    if (textChange !== "") {
      setIsLoading(true);
      getTranslation(textChange)
        .unwrap()
        .then((response) => {
          setData(response);
          dispatch(setListTranslate(cloneDeep(response)));
        })
        .catch((err) => {
          setError(true);
          console.error(t('ERROR_IN_SERVER_CALL'), err);
        })
        .finally(() => setIsLoading(false));
    }
  }, [textChange]);

  useEffect(() => {
    if (data && !hasInitialized.current) {
      const filtered = data.filter(
        (item) => item.language?.trim() && item.translate?.trim()
      );
      setTranslationsListFiltered(filtered);

      setShowTranslationPopup(false);
      setShowTablePopup(true);
      hasInitialized.current = true;
    }
  }, [data]);

  async function onSaveSingle(lang: string, value: string): Promise<boolean> {
    setShowTablePopup(false)
    setShowTranslationPopup(false)
    try {
      if (!lang || !value) {
        setError(true)
        console.error(t('FIELD_OF_LANGUAGE_OR_TRANSLATION'));
        return false;
      }

const req = createUpdateTranslationsRequest(translationKey, [
  {
    language: localStorage.getItem("i18nextLng") || "he",
    translate: value,
    code: localStorage.getItem("i18nextLng") || "he",
  },
],isAdmin);
      const result = await saveTranslation(req).unwrap();
            setSuccess(true)
        setTimeout(() => {
      }, 100000);
      return result;
    } catch (error) {
      setShowTranslationPopup(false);
      setError(true);
      console.error(t('ERROR_IN_SAVING'), error);
      return false;
    }
  }

  async function onSaveAll(): Promise<boolean> {
        setShowTablePopup(false);
    try {
      if (!LangTranslateArr) {
        setError(true)
        return false;

      }

      const req = createUpdateTranslationsRequest(
  translationKey,
  LangTranslateArr,
  isAdmin
);

  

      const result = await saveTranslation(req).unwrap();
      setTimeout(() => {
      setSuccess(true);
        
      }, 100000);


      return result;
    } catch (error) {
      setError(true);
      setShowTablePopup(false)
      console.error(t('ERROR_IN_SAVING'), error);
      return false;
    }
  }

  function onTranslate(text: string): void {
    setTextChange(text);
  }

  function closeAllPopups() {
    setShowTablePopup(false);
    setShowTranslationPopup(false);
    onClose();
  }
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);


  return (
    <>
      {error && !success && <Modal onClose={() => setError(false)}><GeneralErrorPopup onClose={() => setError(false)} /></Modal>}
      {isLoading && <Loader fullscreen />}
 

      {showTranslationPopup && (
        <TranslationPopup
          translationKey={translationKey}
          text={text}
          onClose={() => setShowTranslationPopup(false)}
          onTranslate={onTranslate}
          onSave={onSaveSingle}
          onSaveAll={onSaveAll}
        />
      )}

      {showTablePopup && (
        <TablePopup
          onSaveAll={onSaveAll}
          onClose={() => setShowTablePopup(false)}
        />
      )}
    </>
  );
};

export default AdminTextEditor;
